<template>
  <div>
    <metric-bar :metrics="metrics" />
    <report-base
      title="Property Summary"
      table-class="analytics-tables--summary"
      subject="summary"
      :stacked="true"
      :search="false"
      :items="summary"
      :fields="fields"
      :is-loading="loading"
      @reload="loadData"
    />
  </div>
</template>

<script>
/* eslint-disable */
import MetricBar from "@/components/MetricBar.vue";
import AnalyticsMixin from "./mixin";

export default {
  name: "analytics-summary",

  mixins: [AnalyticsMixin],

  components: {
    MetricBar,
  },

  data() {
    return {
      summary: [],
      metrics: [],
      fields: [
        {
          key: "property_revenue",
          label: "Property Revenue", // this.$t("analytics.summary.hotel_revenue"),
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
        {
          key: "hotel_revenue",
          label: this.$t("analytics.summary.hotel_revenue"),
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
        {
          key: "sales_revenue",
          label: "Sales Revenue", // this.$t("analytics.summary.sales_revenue"),
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
        {
          key: "occupancy_rate",
          label: this.$t("analytics.summary.occupancy_rate"),
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
        {
          key: "adr",
          label: this.$t("analytics.summary.average_daily_rate"),
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
        {
          key: "rev_par",
          label: this.$t("analytics.summary.revpar"),
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
        {
          key: "total_no_guests",
          label: this.$t("analytics.summary.total_no_guests"),
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
        {
          key: "total_no_bookings",
          label: "Total No. Bookings",
          sortable: true,
          thStyle: "background-color: #f5f5f5;",
        },
      ],
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;

      this.fetchData("summary")
        .then((res) => {
          this.summary = res.data.map((item) => {
            item.property_revenue = this.formatMoney(item.property_revenue);
            item.hotel_revenue = this.formatMoney(item.hotel_revenue);
            item.sales_revenue = this.formatMoney(item.sales_revenue);
            item.occupancy_rate = this.formatPercent(item.occupancy_rate);
            item.adr = this.formatMoney(item.adr);
            item.rev_par = this.formatMoney(item.rev_par);

            return item;
          });

          if (this.summary.length) {
            const s = this.summary[0];
            this.metrics = [
              {
                id: "property_revenue",
                label: "Property Revenue",
                value: s.property_revenue,
              },
              {
                id: "occupancy_rate",
                label: "Occupancy",
                value: s.occupancy_rate,
              },
            ];
          }
        })
        .catch(() => {
          this.errorNotification("Feching summary data error!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.table.b-table.b-table-stacked {
  width: 98%;
  margin-left: auto;
  margin-right: auto;
  font-size: 16px;
}

.overview-select {
  display: inline-block;
  width: 10%;
  margin: 20px 0px;
}

.analytics-tables--summary {
  td {
    font-size: 16px !important;
  }
}
</style>
